import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "AcquisitionTypeListPage" */
	'pages/vehicle/AcquisitionType/AcquisitionTypeListPage'));

export default [{ component, exact: true, path: '/acquisition_types' }];